import DataExtensionField from "./DataExtensionField.vue";
import dataExtensionSchema from "../services/data-extension-schema.js"
import flywheelSFMCUtilFactory from "@/services/flywheel-sfmc-util"
import ProcessStatusView from "@/components/ProcessStatusView.vue";
import FolderSelector from "@/components/FolderSelector.vue";
import XLSX from "xlsx";

export default {
    name: 'DataExtension',
    components: {
        DataExtensionField,
        ProcessStatusView,
        FolderSelector
    },
    props: [
        "id",
        "deParams",
        "creationStationFormProperties",
        "processStatus",
        "parentPath"
    ],
    data: function() {
        return {
            params: {
                name: "",
                customer_key: "",
                description:"",
                path: "",
                properties: {
                    IsSendable: "false",
                    IsTestable: "false",
                    SendableSubscriberField: {
                        Name: "Subscriber Key"
                    },
                    SendableDataExtensionField: {
                        Name: null
                    }
                }
            },
            dataBak: null,
            fields: [],
            fieldsSequence: 1,
            deRows: [],
            sendableSubscriberFields: ["Subscriber Key", "Subscriber ID", "Email Address"],
            rawData: "",
            deBeingEdited: false,
            formProperties: {
                deParamsBeingEdited: false,
                fieldBeingEdited: null,
                fieldDataTypes: dataExtensionSchema.getFieldDataTypes()
            },
            useParentDEPath: "false"
        };
    },
    created: function() {
        this.$folderUtil = flywheelSFMCUtilFactory(this, "folder");
    },
    mounted: function() {
        this.$emit("DataExtension:editing", this.id);
        this.deBeingEdited = true;
        this.formProperties.deParamsBeingEdited = true;
        //this.setTestParams();
        //console.log(this.parentPath);
    },
    computed: {
        hasEmailField: function() {
            var result = false;
            if (this.fields.length) {
                this.fields.forEach((field) => {
                    if (field.properties.FieldType == "EmailAddress") {
                        result = true;
                    }
                });
            }
            return result;
        },
        fieldNamesSendable: function() {
            var fieldNames = [];
            if (this.fields.length) {
                this.fields.forEach((field) => {
                    if (field.properties.FieldType == "EmailAddress") {
                        fieldNames.push(field.properties.Name);
                    }
                })
            }
            return fieldNames;
        }
    },
    watch: {
        useParentDEPath: function(v) {
            if (v == "true") {
                this.updateParentPath();
            }
        },
        parentPath: function() {
            this.updateParentPath();
        }
    },
    methods:  {
        makeDESchema: function() {
            var result = dataExtensionSchema.makeFromRows(this.splitData(this.rawData));
            this.deRows = result.rows;
            this.fields = [];
            result.fields.forEach((field) => {
                this.fields.push({
                    id: this.fieldsSequence++,
                    properties: field
                });
            });

            if (result.sendableField) {
                this.params.properties.SendableDataExtensionField.Name = result.sendableField;
                this.params.properties.IsSendable = "true";
            }
        },
        updateDEParams: function() {
            this.dataBak = {
                params: JSON.parse(JSON.stringify(this.params)),
                rawData: this.rawData
            };
            if (!this.fields.length) {
                this.makeDESchema();
            }
            // if (this.hasEmailField && !this.params.properties.SendableDataExtensionField.Name) {
            //     this.params.properties.SendableDataExtensionField.Name = this.fieldNamesSendable[0];
            // }
            this.formProperties.deParamsBeingEdited = false;
        },
        editDataExtension: function() {
            this.$emit("DataExtension:editing", this.id);
        },
        updateDataExtension: function() {
            var params = {};

            if (this.formProperties.deParamsBeingEdited) {
                alert("Please finish editing data extension parameters before submitting");
                return;
            }

            if (this.formProperties.fieldBeingEdited) {
                alert("Please finish editing fields before submitting");
                return;
            }

            Object.keys(this.params).forEach((paramName) => {
                params[paramName] = this.params[paramName];
            })
            params.properties.Fields = {
                Field: []
            };
            this.fields.forEach(field => {
                var properties = {};
                Object.keys(field.properties).forEach((propertyName) => {
                    properties[propertyName] = field.properties[propertyName];
                });
                params.properties.Fields.Field.push(properties);
            })

            params = JSON.parse(JSON.stringify(params));

            if (params.properties.IsSendable != "true") {
                delete params.properties.SendableSubscriberField;
                delete params.properties.SendableDataExtensionField;
            }

            //console.log(JSON.stringify(params, null, 4));
            this.$emit("DataExtension:update", this.id, params, this.deRows);
            this.deBeingEdited = false;
        },
        deleteDataExtension: function() {
            if (confirm("Really delete this data extension"))
            this.$emit("DataExtension:delete", this.id);
        },
        splitData: function(str) {
            var rows = [];
            var headers = null;
            var wb = XLSX.read(str, { type: 'string' });
            XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]).forEach((rowObj) => {
                var row = [];
                if (!headers) {
                    headers = [];
                    Object.keys(rowObj).forEach((k) => {
                        headers.push(k);
                    });
                    rows.push(headers);
                }
                headers.forEach((header) => {
                    row.push(rowObj[header]);
                });
                rows.push(row);
            });
            return rows;
            //str.replace(/^\s+/, '').replace(/\s+$/, '').split(/\n/).forEach((line) => {
            //    rows.push(line.split(/\t/));
            //});
            //return rows;
        },
        dataExtensionFieldEditing: function(id) {
            if (!this.formProperties.fieldBeingEdited) {
                this.formProperties.fieldBeingEdited = id;
            } else {
                alert("Please finish editing the currently open field before proceeding");
            }
        },
        dataExtensionFieldUpdate: function(id, properties) {
            var i;
            if (this.formProperties.fieldBeingEdited == id) {
                this.formProperties.fieldBeingEdited = null;
            }

            for (i = 0; i < this.fields.length; i++) {
                if (this.fields[i].id == id) {
                    this.fields[i].properties = properties;
                    break;
                }
            }

            // if (!this.hasEmailField) {
            //     this.params.properties.IsSendable = "false";
            // } else if (!this.params.properties.SendableDataExtensionField.Name) {
            //     this.params.properties.SendableDataExtensionField.Name = this.fieldNamesSendable[0];
            // }
        },
        dataExtensionFieldChange: function(action, data) {
            var i;
            //console.log("action", action);
            //console.log("data", data);
            switch (action) {
                case "editing":
                    this.formProperties.fieldBeingEdited = data.id;
                    break;
                case "updated":
                    for (i = 0; i < this.fields.length; i++) {
                        if (this.fields[i].id == data.id) {
                            this.fields[i].properties = data.properties;
                            break;
                        }
                    }
                    this.formProperties.fieldBeingEdited = null;
                    // if (!this.hasEmailField) {
                    //     this.params.properties.IsSendable = "false";
                    // } else if (!this.params.properties.SendableDataExtensionField.Name) {
                    //     this.params.properties.SendableDataExtensionField.Name = this.fieldNamesSendable[0];
                    // }
                    break;
            }
        },
        setTestParams: function() {
            this.params.name = "FlywheelTest20190227A2";
            this.params.customer_key = "FlywheelTest20190227A2";
            this.params.description = "TestDescr";
            this.params.path = "Data Extensions>PH_Test";
            this.rawData = `EmailAddress(pk,reqd,sendable)	product_0_sku(reqd)	product_0_original_price	product_0_browse_time	product_0_metric_id	Date_Added
Collegepsychegrad@gmail.com	10000656-A01	70	2/26/19 9:07		2/27/19 14:06
jonathan.talsma@converse.com	10000656-A01	70	2/26/19 0:21		2/27/19 14:06
kim.phan@converse.com	10000656-A01	70	2/26/19 14:40		2/27/19 14:06
ptrckhyns+cnv.price-drop.1550701462.3@gmail.com	10000656-A01	65.97	2/19/19 22:24		2/27/19 14:06
ptrckhyns+cnv.price-drop.1550701578.1@gmail.com	10000656-A01	65.97	2/19/19 22:26		2/27/19 14:06
ptrckhyns+cnv.price-drop.1550701578.2@gmail.com	10000656-A01	65.97	2/19/19 22:34		2/27/19 14:06
ptrckhyns+cnv.price-drop.1550701578.3@gmail.com	10000656-A01	65.97	2/19/19 22:34		2/27/19 14:06
ashley.struth@converse.com	10007144-A04	49.97	2/25/19 13:46		2/27/19 14:06
ptrckhyns+cnv.price-drop.1550768220.1.drop@gmail.com	10009222-A01	10.97	2/20/19 16:57		2/27/19 14:06
ptrckhyns+cnv.price-drop.1550768220.3.drop@gmail.com	10009222-A01	10.97	2/20/19 16:57		2/27/19 14:06
ptrckhyns+cnv.price-drop.1550768220.2.drop@gmail.com	162554C	60.47	2/20/19 16:57		2/27/19 14:06`;
            //this.makeDESchema();
        },

        folderSelected: function(id, path) {
            this.params.path = path;
        },

        updateParentPath: function() {
            if (this.useParentDEPath == "true") {
                this.params.path = this.parentPath
            }
        }
    }
}
